// A legacy wallboard TV upgrades to a screenshot-only session by fetching a new
// custom token, stashing it here and reloading. FirebaseGate signs in with it
// before the app mounts, so the legacy session's data listeners never see the
// user change under them.
const PENDING_SESSION_TOKEN_KEY = 'wallboardPendingSessionToken';

export const setPendingWallboardSessionToken = (token: string) => {
  window.sessionStorage.setItem(PENDING_SESSION_TOKEN_KEY, token);
};

// Returns the pending token (if any) and clears it, so a failed sign-in isn't
// retried in a loop.
export const takePendingWallboardSessionToken = (): string | undefined => {
  const token = window.sessionStorage.getItem(PENDING_SESSION_TOKEN_KEY);
  window.sessionStorage.removeItem(PENDING_SESSION_TOKEN_KEY);
  return token ?? undefined;
};
